import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { TextField, Button, Box, Typography} from '@mui/material';
import { ApiRequest } from '../../services/api';

const EditRecipe = () => {
  const { id } = useParams();
  const [tip, setTip] = useState(null);
  const [imagePreview, setImagePreview] = useState(''); // Para mostrar la vista previa de la imagen
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchRecipe = async () => {
      try {
        const data = await ApiRequest(`api/Tips/${id}`);
        setTip({ ...data, id });
        setImagePreview(data.imagen); // Establecer la imagen previa si ya existe en los datos de la receta
      } catch (error) {
        console.error("Error fetching receta:", error);
      }
    };

    fetchRecipe();
  }, [id]);

  const handleSave = async () => {
    const base64Image = tip.imagen.split(',')[1];
      const tipData = {
        TipId: tip.id,
        titulo: tip.titulo,
        descripcion: tip.descripcion,
        cuerpo: tip.cuerpo,
        imagen: base64Image, // Asegúrate de que la imagen esté en formato base64
      };
  
      try {
        setIsLoading(true);
        await ApiRequest(`api/tips/ActualizarTip`, 'PUT', tipData);
        navigate('/Dashboard/Recetas');
      } catch (error) {
        console.error('Error updating receta:', error);
      } finally {
        setIsLoading(false);
      }
    };


  const handleImageChange = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onloadend = () => {
      const base64String = reader.result;
      setTip({ ...tip, imagen: base64String });
      setImagePreview(base64String); // Mostrar la imagen cargada como vista previa
    };

    if (file) {
      reader.readAsDataURL(file);
    }
  };

  if (!tip) return <div>Loading...</div>;

  return (
    <Box sx={{ padding: 3 }}>
      <Typography variant="h4" gutterBottom>
        Editar Tip
      </Typography>
      <TextField
        label="Titulo"
        value={tip.titulo}
        onChange={(e) => setTip({ ...tip, titulo: e.target.value })}
        fullWidth
        margin="normal"
      />
      <TextField
        label="Descripción"
        value={tip.descripcion}
        onChange={(e) => setTip({ ...tip, descripcion: e.target.value })}
        fullWidth
        margin="normal"
        multiline
        rows={4}
      />
      <TextField
        label="Cuerpo"
        value={tip.cuerpo}
        onChange={(e) => setTip({ ...tip, cuerpo: e.target.value })}
        fullWidth
        margin="normal"
        multiline
        rows={6}
      />

      <Typography variant="h6" gutterBottom>
        Imagen del Tip
      </Typography>
      <button class="upload-file-button">
        <svg
          aria-hidden="true"
          stroke="currentColor"
          stroke-width="2"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            stroke-width="2"
            stroke="#fffffff"
            d="M13.5 3H12H8C6.34315 3 5 4.34315 5 6V18C5 19.6569 6.34315 21 8 21H11M13.5 3L19 8.625M13.5 3V7.625C13.5 8.17728 13.9477 8.625 14.5 8.625H19M19 8.625V11.8125"
            stroke-linejoin="round"
            stroke-linecap="round"
          ></path>
          <path
            stroke-linejoin="round"
            stroke-linecap="round"
            stroke-width="2"
            stroke="#fffffff"
            d="M17 15V18M17 21V18M17 18H14M17 18H20"
          ></path>
        </svg>
        Cargar Imagen de Tip
        <input type="file" accept="image/*" onChange={handleImageChange} />
      </button>

      {(imagePreview || tip.imagen) && (
        <Box mt={2}>
          <img
            src={imagePreview || tip.imagen}
            alt="Vista previa del tip"
            style={{ width: '100%', maxHeight: '300px', objectFit: 'contain' }}
          />
        </Box>
      )}


      <Button
        variant="contained"
        color="primary"
        onClick={handleSave}
        sx={{ mt: 2 }}
      >
        Guardar
      </Button>
    </Box>
  );
};

export default EditRecipe;
